module.exports = __webpack_public_path__ + "img/MX-A024D-AS-HQ.6c960c90.png";